import React,
{ useState, useEffect, useMemo, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import {
    FormControlLabel,
    FormControl,
    FormLabel,
    MenuItem,
    Modal,
    Radio,
    RadioGroup,
    Tooltip,
    TextField,
    Typography,
} from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';

import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';

import { NavTopMenu } from '../shared/NavTopMenu';
import { Footer } from '../shared/Footer';
import { SidebarMenu } from '../shared/SidebarMenu';

import { useTable, useRowSelect } from "react-table";

import Swal from 'sweetalert2';

import { sha256 } from 'js-sha256';

import '../../styles/style.scss';
import '../../styles/paymentScreenStyle.scss';
import { font } from '../../constants/styles/styles';

import PaymentService from '../../services/payment.service';

import { convertDateToJulian } from '../../constants/component/convertDateToJulian';
import { sesionExpired } from '../../constants/auth/sesionExpired';
import { timeSessionDifference } from '../../constants/auth/timeSessionDifference';
import { actionErrorConnection } from "../../constants/component/actionErrorConnection";
import usersService from '../../services/users.service';
import { CustomCheckbox } from '../../constants/customComponent/CustomCheckbox';
import { ADMINISTRADOR_ZONA } from '../../constants/models/typeOperationRol';

export const PaymentScreen = () => {

    const { isLoggedIn, user } = useSelector(state => state.auth);
    const an8Logged = isLoggedIn ? user.noCustomer : '---';
    const operationRol = isLoggedIn? user.operationRol:'---';

    const tokenExpired = process.env.REACT_APP_TIME_EXPIRED_TOKEN;
    const sessionDifference = timeSessionDifference();

    const baseUrl = process.env.REACT_APP_API_URL;

    const dispatch = useDispatch();
    const history = useHistory();

    const CustomRadio = withStyles({
        root: {
            color: font.baseCheckboxColor,
            '&$checked': {
                color: font.baseColor,
            },
        },
        checked: {},
    })((props) => <Radio color="default" {...props} />);

    let dateSubtract = new Date();
    let dateSubtractPayment = new Date();

    dateSubtract.setMonth(dateSubtract.getMonth() - 3);
    dateSubtractPayment.setMonth(dateSubtractPayment.getMonth() - 1);

    const dateMin = dateSubtract;
    const dateMinPayment = dateSubtractPayment;
    const dateMax = new Date();

    const [customers, setCustomers] = useState({
        isLoading: true,
        isDisabled: true,
        data: []
    });

    const [invoiceType, setInvoiceType] = useState({
        isLoading: true,
        isDisabled: true,
        data: []
    })

    const [isBlocked, setIsBlocked] = useState(false); // provisional para bloquear usuarios
    //lista de usuarios bloqueados;
    const userListBlocked = [
        //'1009731',
        //'1009746',
        //'1065816',
        //'1065898',
        //'1066037',
        //'1078770',
        //'1081164',
        //'1093748',
        //'1096488',
        //'1103879',
        //'1108315',
        //'1108327',
        //'1114480',
        //'1123029',
        //'1130617',
        //'1137476',
        //'1140565',
        //'1146682',
        //'1154112',
        //'1184129',
        //'1196159',
        //'1206945',
        //'1300337',
        //'1322670',
        //'1327151',
        //'1327368',
        //'1330931',
        //'1330959',
    //     '1345312',
    //     '1345321',
    //     '1345333',
    //     //'1364959',
    //     //'1365939',
    //     //'1397028',
    //     //'1410684',
    //     //'1411388',
    //     //'1456706',
    //     //'1473521',
    //     //'1527512',
    //     //'1570160',
    //     //'1576394',
    //     //'1578236',
    //     //'1615248',
    //     //'1615287',
    //     //'180439',
    //     //'18872',
    //     //'18873',
    //     //'18875',
    //     //'18876',
    //     //'18879',
    //     '18887',
    //     //'18888',
    //     //'18894',
    //     '18901',
    //     '18902',
    //     '18904',
    //     '18905',
    //     //'18906',
    //     '18910',
    //     '18917',
    //     '18918',
    //     '18929',
    //     '18931',
    //     '18933',
    //     '18935',
    //     '18945',
    //     '18946',
    //     '18947',
    //     //'18948',
    //     '18949',
    //     '18950',
    //     '18955',
    //     '18961',
    //     //'18965',
    //     '18970',
    //     //'18972',
    //     '18974',
    //     '18975',
    //     '18976',
    //     '18977',
    //     '18979',
    //     '18984',
    //     //'18991',
    //     '18992',
    //     //'18993',
    //     //'18998',
    //     //'18999',
    //     //'19000',
    //     //'19014',
    //     //'19018',
    //     //'19023',
    //     //'19024',
    //     //'19028',
    //     //'19032',
    //     //'19036',
    //     //'19039',
    //     '19041',
    //     '19043',
    //     '19046',
    //     '19049',
    //     '19053',
    //     '19054',
    //     '19055',
    //     '19068',
    //     '19070',
    //     '19071',
    //     '19072',
    //     '19073',
    //     '19076',
    //     '19084',
    //     '19129',
    //     //'19140',
    //     '19251',
    //     '19273',
    //     '19340',
    //     //'19395',
    //     '19451',
    //     '19476',
    //     //'19477',
    //     '19480',
    //     //'19481',
    //     '19483',
    //     '19484',
    //     '19485',
    //     '19486',
    //     '19496',
    //     '19498',
    //     '19502',
    //     //'19503',
    //     '19505',
    //     '19507',
    //     //'19513',
    //     //'19519',
    //     '19521',
    //     //'19525',
    //     '19526',
    //     '19527',
    //     '19533',
    //     //'19535',
    //     '19538',
    //     //'19542',
    //     //'19543',
    //     //'19545',
    //     //'19547',
    //     //'19558',
    //     //'19561',
    //     //'19562',
    //     //'19573',
    //     '19575',
    //     '19576',
    //     '19577',
    //     '19578',
    //     //'19579',
    //     //'19580',
    //     //'19581',
    //     //'19582',
    //     //'19583',
    //     '19585',
    //     '19588',
    //     '19589',
    //     '19590',
    //     //'19592',
    //     //'19594',
    //     '19596',
    //     //'19598',
    //     //'19600',
    //     //'19601',
    //     //'19604',
    //     '19608',
    //     '19613',
    //     //'19622',
    //     //'19623',
    //     '19625',
    //     //'19626',
    //     //'19631',
    //     //'19641',
    //     '19644',
    //     '19654',
    //     //'19655',
    //     '19658',
    //     //'19659',
    //     '19668',
    //     //'19669',
    //     //'19672',
    //     //'19679',
    //     '19683',
    //     //'19684',
    //     //'19691',
    //     //'19695',
    //     '19696',
    //     '19697',
    //     '19698',
    //     //'19702',
    //     //'19707',
    //     //'19712',
    //     //'19714',
    //     //'19715',
    //     //'19716',
    //     '19723',
    //     '19725',
    //     '19727',
    //     '19729',
    //     '19730',
    //     '19733',
    //     '19750',
    //     //'19754',
    //     //'19755',
    //     '19757',
    //     '19760',
    //     '19761',
    //     '19766',
    //     '19767',
    //     '19770',
    //     '19773',
    //     //'19774',
    //     //'19775',
    //     '19778',
    //     '19780',
    //     //'19783',
    //     //'19786',
    //     //'19788',
    //     '19791',
    //     '19792',
    //     '19795',
    //     '19796',
    //     '19797',
    //     '19801',
    //     '19804',
    //     '19808',
    //     '19813',
    //     '19813',
    //     //'19816',
    //     //'19817',
    //     '19824',
    //     //'19830',
    //     //'19831',
    //     //'19832',
    //     '19840',
    //     //'19843',
    //     //'19844',
    //     //'19845',
    //     '19879',
    //     '19884',
    //     '19888',
    //     '19901',
    //     '19916',
    //     //'19926',
    //     //'19927',
    //     '19930',
    //     '19931',
    //     '19932',
    //     '19935',
    //     '19965',
    //     '19971',
    //     '19977',
    //     '19981',
    //     '19982',
    //     //'19986',
    //     '19987',
    //     //'19990',
    //     '19993',
    //     '19999',
    //     '20002',
    //     //'20003',
    //     '20004',
    //     '20011',
    //     //'20012',
    //     //'20014',
    //     '20016',
    //     '20021',
    //     //'20022',
    //     '20024',
    //     '20028',
    //     '20035',
    //     '20039',
    //     '20041',
    //     //'20042',
    //     //'20043',
    //     //'20044',
    //     '20046',
    //     '20050',
    //     '20058',
    //     '20064',
    //     '20067',
    //     '20069',
    //     '20085',
    //     '20087',
    //     '20088',
    //     '20092',
    //     '20097',
    //     '20101',
    //     '20103',
    //     '20113',
    //     //'20115',
    //     '20124',
    //     '20126',
    //     '20132',
    //     '20142',
    //     '20143',
    //     //'20148',
    //     '20151',
    //     //'20155',
    //     '20158',
    //     '20159',
    //     //'20163',
    //     //'20164',
    //     '20176',
    //     '20182',
    //     //'20192',
    //     //'20196',
    //     //'20202',
    //     //'20207',
    //     //'20208',
    //     '20212',
    //     '20217',
    //     '20219',
    //     //'20220',
    //     //'20224',
    //     '20226',
    //     //'20237',
    //     //'20238',
    //     //'20239',
    //     '20255',
    //     '20258',
    //     '20259',
    //     '20261',
    //     '20276',
    //     '20278',
    //     '20283',
    //     '20285',
    //     '20289',
    //     '20292',
    //     '20302',
    //     '20304',
    //     '20311',
    //     //'20314',
    //     //'20315',
    //     //'20318',
    //     //'20320',
    //     //'20325',
    //     '20329',
    //     '20330',
    //     '20340',
    //     '20342',
    //     '20343',
    //     //'20351',
    //     '20368',
    //     '20369',
    //     '20372',
    //     //'20373',
    //     '20377',
    //     //'20378',
    //     //'20381',
    //     //'20384',
    //     '20387',
    //     '20389',
    //     '20398',
    //     '20399',
    //     '20401',
    //     '20411',
    //     '20415',
    //     '20416',
    //     //'20417',
    //     //'20419',
    //     //'20421',
    //     //'20425',
    //     //'20429',
    //     //'20431',
    //     //'261036',
    //     //'308568',
    //     //'314277',
    //     //'32387',
    //     //'374172',
    //     '442116',
    //     //'464339',
    //     //'46560',
    //     //'46677',
    //     //'496354',
    //     '58031',
    //     '678263',
    //     '678277',
    //     '80668',
    //     //'914927',
    //     '920610',
    //     '920651',
    //     '920701',
    //     //'920739',
    //     '942099',
    //     //'942198',
    //     '950868',
    //     '950872',
    //     'ABIGAIL19033',
    //     'AG220104',
    //     'ALEJANDRA19927',
    //     'ALEJANDRO20102',
    //     'ALEXIS19632',
    //     'ANA20102',
    //     'ANTONIO18985',
    //     'ARELY19033',
    //     'CARLOS19520',
    //     'CECILIA18985',
    //     'CEILA18882',
    //     'CHRISTOPHER19927',
    //     'CRISTIAN18882',
    //     'DIANA19899',
    //     'DIEGO180440',
    //     'DIEGO19692',
    //     'DINORA20102',
    //     'ELOY18985',
    //     'FERNANDA18882',
    //     'GEOVANY20102',
    //     'GERARDO19033',
    //     'GUADALUPE20291',
    //     'HECTOR20102',
    //     'ISAURA1365940',
    //     'J19050',
    //     //'JACQUELINE19033',
    //     //'JAFET1568604',
    //     //'JOSE19690',
    //     //'JUAN19096',
    //     //'LETICIA18990',
    //     //'LILIA18951',
    //     'LISBETH19033',
    //     'LOLITA20220',
    //     'LUZ19096',
    //     'MANOLO19690',
    //     'MANUEL20291',
    //     //'MARIA20220',
    //     //'MARIANA19011',
    //     //'MARIBEL19520',
    //     'MARIO19514',
    //     'MARTHA19096',
    //     'MARY19042',
    //     'MIGUEL18882',
    //     'MIGUEL18985',
    //     'MIGUEL20102',
    //     'MIRIAM20270',
    //     'MONICA1365940',
    //     'MONICA18882',
    //     'NORMA18985',
    //     'OLGA19775',
    //     'PAULA20235',
    //     'PISOS20104',
    //     'PRUEBAS19717',
    //     'QUETZALLY19033',
    //     'REYNOL19692',
    //     'ROCIO19632',
    //     'ROSY20102',
    //     'RUBI19033',
    //     'SAN20102',
    //     'SEBASTIAN19632',
    //     'SERGIO20270',
    //     'SIMON20047',
    //     'VALERIA18882',
    //     'YANINA19692',
     ];

    const [selectStartDate, handleStartDateChange] = useState(null);
    const [selectEndDate, handleEndDateChange] = useState(null);
    const [selectStartExpitationDate, handleStartExpirationDateChange] = useState(null);
    const [selectEndExpitationDate, handleEndExpirationDateChange] = useState(null);

    const [dataFilters, setDataFilters] = useState(null);

    const [selectedStatusValue, setSelectedStatusValue] = useState('false');

    const [isDownloadFile, setIsDownloadFile] = useState(false);
    const [isLoadingData, setIsLoadingData] = useState(false);
    const [errorResponse, setErrorResponse] = useState('');
    const [isErrorResponse, setIsErrorResponse] = useState(false);

    const [detailPayment, setDetailPayment] = useState([]);
    const [isActivedAll, setIsActivedAll] = useState(false);

    const [amountPayment, setAmountPayment] = useState(0);
    const [dataPayment, setDataPayment] = useState([]);

    const [isLoadingStartPayment, setIsLoadingStartPayment] = useState(false);
    const [dataStartPayment, setDataStartPayment] = useState({})

    const [open, setOpen] = useState(false);

    const paymentRef = useRef();

    paymentRef.current = detailPayment;

    const validationSchema = Yup.object().shape({
        an8: Yup.string().required('cliente requerido'),
        // startDate: Yup.date().default(selectStartDate),
        // endDate: Yup.date().default(selectEndDate)
        //     .min(selectStartDate ? selectStartDate : dateMin)
    });

    const {
        control,
        handleSubmit,
        getValues,
        register
    } = useForm({
        resolver: yupResolver(validationSchema),
    });

    const columns = useMemo(
        () => [
            {
                id: 'selection',
                isVisible: operationRol !== ADMINISTRADOR_ZONA,
                Header: () => {

                    let isAnyPaymentProcessing = false;

                    detailPayment.forEach(({ active }) => {
                        if (active === 'false') isAnyPaymentProcessing = true;
                    })


                    const handleSelect = () => {
                        let newInvoiceList = [];
                        detailPayment.forEach((data) => {
                            newInvoiceList.push({
                                ...data,
                                isChecked: !isActivedAll
                            });
                            setDetailPayment(newInvoiceList);
                            setIsActivedAll(!isActivedAll);
                        })
                    }
                    return (
                        <div className='col-12 d-flex flex-row'>
                            <Tooltip title={isAnyPaymentProcessing ? 'Existen pagos sin procesar' : (!isActivedAll ? 'Seleccionar todos' : 'Desmarcar todos')} placement="top-start" arrow>
                                <FormControlLabel
                                    className="w-100 ms-2 me-0"
                                    control={
                                        <CustomCheckbox className=' ps-0 ms-0'
                                            color="primary"
                                            onChange={() => handleSelect()}
                                            checked={isActivedAll && !isAnyPaymentProcessing}
                                            indeterminate={isAnyPaymentProcessing}
                                            disabled={isAnyPaymentProcessing}
                                        />
                                    }
                                />
                            </Tooltip>
                        </div>
                    )
                },
                Cell: (propsCells) => {
                    const rowIdx = propsCells.row.id;
                    const [invoiceActived, setInvoiceActived] = useState(detailPayment[rowIdx]);

                    const handleSelect = () => {
                        const selectChange = {
                            ...invoiceActived,
                            isChecked: !invoiceActived?.isChecked
                        };
                        setInvoiceActived(selectChange);
                        const newInvoiceList = Object.values({ ...detailPayment, [rowIdx]: selectChange });
                        const checkedAll = newInvoiceList.filter(({ isChecked }) => isChecked === false);
                        setIsActivedAll(checkedAll?.length > 0 ? false : true);
                        setDetailPayment(newInvoiceList);
                    }
                    return (
                        <div className='col-12 d-flex flex-row'>
                            <Tooltip title={invoiceActived?.active === 'false' ? 'el pago aún no esta procesado' : ''} placement="top-start" arrow>
                                <FormControlLabel
                                    className="w-100 ms-2 me-0"
                                    control={
                                        <CustomCheckbox className=' ps-0 ms-0'
                                            color="primary"
                                            onChange={() => handleSelect()}
                                            checked={invoiceActived?.isChecked}
                                            indeterminate={invoiceActived?.active === 'false'}
                                            disabled={invoiceActived?.active === 'false'}
                                        />
                                    }
                                />
                            </Tooltip>
                        </div>
                    )
                }
            },
            {
                id: 'an8',
                Header: 'Cliente',
                accessor: 'an8',
                isVisible: true,
            },
            {
                id: "number",
                Header: "Número factura",
                accessor: "number",
                isVisible: true
            },
            {
                id: "type",
                Header: "Tipo factura",
                accessor: "type",
                isVisible: true
            },
            {
                id: "linkedSale",
                Header: "O. Venta",
                accessor: "linkedSale",
                isVisible: true
            },
            {
                id: "date",
                Header: "Fecha factura",
                accessor: "date",
                isVisible: true
            },
            {
                id: "expiration",
                Header: "Fecha vencimiento",
                accessor: "expiration",
                isVisible: true
            },
            {
                id: "invoiceAmount",
                Header: "Importe factura",
                accessor: "invoiceAmount",
                isVisible: true
            },
            {
                id: "pendingAmount",
                Header: "Importe pendiente",
                accessor: "pendingAmount",
                isVisible: true
            },
            {
                id: "amountPayable",
                Header: "Importe pagar",
                accessor: "amountPayable",
                isVisible: true,
                Cell: (propsCells) => {
                    const rowIdx = propsCells.row.id;
                    const [invoiceActived, setInvoiceActived] = useState(detailPayment[rowIdx]);

                    const handleCatchValue = (event) => {
                        const articleChange = { ...invoiceActived, amountPayable: event.target.value };
                        setInvoiceActived(articleChange);
                    };

                    const handleChangeValue = (event) => {
                        const regexNumber = /^[+]?([0-9]+\.?[0-9]*|\.[0-9]+)$/;
                        const amountConvert = event.target.value?.replace(/,/g,'');
                        const amountChange = {
                            ...invoiceActived,
                            amountPayable: parseFloat(amountConvert)?.toLocaleString('es-Mx'),
                            amountPayableError: (!regexNumber.test(parseFloat(amountConvert)) || parseFloat(amountConvert) < 0 || parseFloat(amountConvert) > parseFloat(detailPayment[rowIdx].invoiceAmount?.replace(/,/g,'')))
                        };
                        const newInvoiceList = Object.values({ ...detailPayment, [rowIdx]: amountChange });
                        setDetailPayment(newInvoiceList);
                    };
                    return (
                        <div className="d-flex justify-content-center">
                            <div className='w-100'>
                                <Tooltip title='editar' placement="top-start">
                                    <div className=''>
                                        <TextField
                                            className='bg-white'
                                            id="amountPayable"
                                            name="amountPayable"
                                            label=''
                                            type="text"
                                            variant="outlined"
                                            size="small"
                                            value={invoiceActived?.amountPayable || ''}
                                            onBlur={handleChangeValue}
                                            onChange={handleCatchValue}
                                            inputProps={{
                                                style: { textAlign: 'center' },
                                            }}
                                        />
                                        <Typography variant="inherit" color="error">
                                            {detailPayment[rowIdx]?.amountPayableError && 'No puede ser menor a cero o mayor a la cantidad diponible'}
                                        </Typography>
                                    </div>
                                </Tooltip>
                            </div>
                        </div>
                    );
                },
            },
            {
                id: "line",
                Header: "Línea",
                accessor: "line",
                isVisible: true
            },
            {
                Header: "Acciones",
                accessor: "actions",
                isVisible: true,
                Cell: (props) => {

                    const rowIdx = props.row.id;

                    const downloadFile = (e, typeFile, id) => {

                        const paymentSelect = paymentRef.current[id];

                        // const fileName = paymentSelect.number+paymentSelect.type;


                        const arrayPayment = {
                            'date': paymentSelect.date,
                            'invoiceNumber': paymentSelect.number,
                            'invoiceType': paymentSelect.type,
                            'format': typeFile
                        };

                        if (typeFile === 'pdf') {
                            PaymentService.downloadPayment(arrayPayment).then(
                                (response) => {

                                    const byteString = window.atob(response.data.split(',')[1]);
                                    const mimeString = response.data.split(',')[0].split(':')[1].split(';')[0];

                                    const ab = new ArrayBuffer(byteString.length);
                                    const ia = new Uint8Array(ab);
                                    for (let i = 0; i < byteString.length; i++) {
                                        ia[i] = byteString.charCodeAt(i)
                                    }

                                    const dataBlob = new Blob([ab], { type: mimeString });

                                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                        window.navigator.msSaveOrOpenBlob(dataBlob, `${response.name}.pdf`);
                                        return
                                    }

                                    const url = window.URL.createObjectURL(dataBlob);
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', `${response.name}.pdf`);
                                    document.body.appendChild(link);
                                    link.click();
                                    link.remove();
                                },
                                (error) => {

                                    if (error.response) {
                                        console.log(error.response.data.message)
                                        const message = error.response.data.message.split(':');
                                        actionErrorConnection(error, `${message[1]}`);
                                    } else {
                                        actionErrorConnection(error, 'Error al descargar archivo PDF.');
                                    }
                                });

                            console.log('descargar archivo pdf');

                        } else if (typeFile === 'xml') {
                            PaymentService.downloadPayment(arrayPayment).then(
                                (response) => {
                                    console.log('ok descarga');
                                    const byteString = window.atob(response.data.split(',')[1]);
                                    const mimeString = response.data.split(',')[0].split(':')[1].split(';')[0];

                                    const ab = new ArrayBuffer(byteString.length);
                                    const ia = new Uint8Array(ab);
                                    for (let i = 0; i < byteString.length; i++) {
                                        ia[i] = byteString.charCodeAt(i)
                                    }

                                    const dataBlob = new Blob([ab], { type: mimeString });

                                    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                                        window.navigator.msSaveOrOpenBlob(dataBlob, `${response.name}.xml`);
                                        return
                                    }

                                    const url = window.URL.createObjectURL(dataBlob);
                                    const link = document.createElement('a');
                                    link.href = url;
                                    link.setAttribute('download', `${response.name}.xml`);
                                    document.body.appendChild(link);
                                    link.click();
                                    link.remove();
                                },
                                (error) => {
                                    actionErrorConnection(error, 'Error al descargar archivo xml.');
                                });
                            console.log('descargar archivo xml');
                        }
                    };

                    return (
                        <div>
                            <Tooltip title="Descargar PDF" placement="top-start" arrow>
                                <button className="btn custom-btn-icons"
                                    onClick={(e) => downloadFile(e, 'pdf', rowIdx)}
                                >
                                    <i className="fas fa-file-pdf mr-1"></i>
                                </button>
                            </Tooltip>
                            <Tooltip title="Descargar XML" placement="top-start" arrow>
                                <button className="btn custom-btn-icons"
                                    onClick={(e) => downloadFile(e, 'xml', rowIdx)}
                                >
                                    <i className="fas fa-file-code"></i>
                                </button>
                            </Tooltip>
                        </div>
                    );
                },
            }
        ],
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [detailPayment, isActivedAll]
    );

    useEffect(() => {
        getCustomers();
        getInvoiceTypes()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    /**
   * Recupera la lista de clientes
   * @param {string} an8 - identificador del cliente
   * @author alSanchez - ETE
   * @version 1.0.0 - Noviembre 2023
   */
    const getCustomers = () => {

        setCustomers({
            isLoading: true,
            isDisabled: true,
            data: []
        })
        usersService.getCustomerAssociatesByAN8(an8Logged).then((response) => {
            let customersResponse = response;

            setCustomers({
                isLoading: false,
                isDisabled: false,
                data: customersResponse
            });
        }).catch((error) => {
            console.log(error);
            setCustomers({
                isLoading: false,
                isDisabled: false,
                data: ['']
            });

            if (sessionDifference > Number(tokenExpired)) {
                sesionExpired(dispatch, history);
            } else {
                actionErrorConnection(error, 'Error al recuperar clientes.');
            }
        });
    }

     /**
   * Recupera tipo de facturas
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024
   */
     const getInvoiceTypes = () => {

        setInvoiceType({
            isLoading: true,
            isDisabled: true,
            data: []
        })
        PaymentService.getInvoicesType().then((response) => {

            setInvoiceType({
                isLoading: false,
                isDisabled: false,
                data: response
            });
        }).catch((error) => {
            console.log(error);
            setInvoiceType({
                isLoading: false,
                isDisabled: false,
                data: []
            });

            if (sessionDifference > Number(tokenExpired)) {
                sesionExpired(dispatch, history);
            } else {
                actionErrorConnection(error, 'Error al recuperar tipos de facturas.');
            }
        });
    }

    /**
       * Recupera el an8 seleccionado
       * @author alSanchez - ETE
       * @version 1.0.0 - Noviembre 2023
       *
      */
    const onCustomerChange = () => {
        const params = getValues();
        if (params.an8 && params.an8 !== '') {
            if (userListBlocked.filter((data) => String(data) === String(params.an8))?.length > 0) setIsBlocked(true)
            onSubmit();
            getPendingPayment(params.an8);
        }
    }

    /**
     * Recupera estado de pago pendiente por an8
     * @param {string} an8 - identificador del cliente
     * @author alSanchez - ETE
     * @version 1.0.0 - Dociembre 2023
     */
    const getPendingPayment = (an8) => {

        PaymentService.getstatusPendingPayment(an8).then((response) => {
            if (response) {
                Swal.fire({
                    title: '',
                    html: `<span>El cliente ${getValues().an8} puede generar anticipos. ¿Desea ir a los pagos anticipados para generar un anticipo? </span>`,
                    icon: 'info',
                    showConfirmButton: true,
                    confirmButtonText: 'Aceptar',
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    reverseButtons: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        history.push({
                            pathname: `/operation/advance-payment`,
                            state: {
                                customer: getValues().an8
                            }
                        });
                        window.location.reload();
                    }
                })
            }
        }).catch((error) => {
            if (sessionDifference > Number(tokenExpired)) {
                sesionExpired(dispatch, history);
            } else {
                actionErrorConnection(error, 'Error al recuperar estado de pagos pendientes.');
            }
        });
    }

    const handleChangeStatus = (event) => {
        setSelectedStatusValue(event.target.value);
        handleStartDateChange(null);
        handleEndDateChange(null);
        handleEndExpirationDateChange(null);
        handleStartExpirationDateChange(null);
        const an8 = getValues().an8;
        if(an8 && an8 !== ''){
            onSubmit(null, true);
        }
    };

    /**
   * Recupera tipo de facturas
   * @param {Object} data - información de filtros
   * @param {Boolean} changeStatus - valida que se esta realizando un cambio de estado de factura
   * @author alSanchez - ETE
   * @version 1.0.0 - Febrero 2024 - se agregan filtros
   */
    const onSubmit = (data, changeStatus) => {
        console.log('test')

        const element = document.getElementById('collapseExample');
        element.classList.remove('show');

        setDetailPayment([]);
        setAmountPayment(0);

        setIsLoadingData(true);
        setIsErrorResponse(false);

        const an8 = getValues().an8;
        const typeInvoice = getValues().typeInvoice;

        let params = {};

        if (!data) {
            let initDate = dateMin;
            console.log(selectedStatusValue)
            if (dataFilters) {
                params = dataFilters;
            } else {
                initDate = selectedStatusValue  === 'true' ? dateMinPayment : dateMin;
                params = {
                    startDate: convertDateToJulian(initDate),
                    endDate: convertDateToJulian(dateMax),
                    invoice: selectedStatusValue,
                    typeInvoice: typeInvoice,
                    startExpirationDate: convertDateToJulian(initDate),
                    endExpirationDate: convertDateToJulian(dateMax),
                };
                setDataFilters(null);
            }
            if (changeStatus) {

                initDate = selectedStatusValue  === 'true' ? dateMin : dateMinPayment;
                console.log('change')
                params = {
                    startDate: convertDateToJulian(initDate),
                    endDate: convertDateToJulian(dateMax),
                    invoice: selectedStatusValue === 'true' ? 'false' : 'true',
                    typeInvoice: typeInvoice,
                    startExpirationDate: convertDateToJulian(initDate),
                    endExpirationDate: convertDateToJulian(dateMax),
                };
                setDataFilters(null);
            }
            console.log(initDate)
        } else {
            params = {
                startDate: convertDateToJulian(selectStartDate),
                endDate: convertDateToJulian(selectEndDate),
                invoice: selectedStatusValue,
                typeInvoice: typeInvoice,
                startExpirationDate: selectStartExpitationDate ? convertDateToJulian(selectStartExpitationDate) : convertDateToJulian(selectStartDate),
                endExpirationDate: selectEndExpitationDate ? convertDateToJulian(selectEndExpitationDate) : convertDateToJulian(selectEndDate)
            };

            setDataFilters(params);
        }

        getDetailPaymentByFilters(params, an8);

    };

    const getDetailPaymentByFilters = (params, an8) => {
        PaymentService.getAlldetailPaymentByFilters(params, an8)
            .then((response) => {
                setIsErrorResponse(false);
                setIsLoadingData(false);
                const { invoice } = response;
                invoice.forEach((data,index)=>{
                    let orderLinkedSale = invoice[index].linkedSale
                    invoice[index]= {...invoice[index], amountPayable: parseFloat(invoice[index].amountPayable)?.toLocaleString('es-Mx'), linkedSale: orderLinkedSale ? invoice[index].linkedSale.split("-")[1] + "-" + invoice[index].linkedSale.split("-")[0] : "0"}
                })
                setDetailPayment(invoice);
            })
            .catch((error) => {
                setDetailPayment([]);
                setIsLoadingData(false);
                if (error.response) {

                    setErrorResponse(error.response?.data?.state || error.response?.data?.mensaje);

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    }
                } else {
                    setErrorResponse(error);
                    actionErrorConnection(error);
                }
                setIsErrorResponse(true);

            });
    }
    const startServicePaiment = (event) => {
        event.preventDefault();

        setIsLoadingStartPayment(true);

        let paymentArray = [];

        const selectedRows = detailPayment.filter(({ isChecked }) => isChecked === true);

        selectedRows?.forEach(row => {

            const totalPayment = paymentArray.length === 0 ? amountPayment : 0;
            paymentArray.push(
                {
                    "billNumber": row.number,
                    "typeBill": row.type,
                    "billDate": row.date,
                    "amount": parseFloat(row.amountPayable?.replace(/,/g,''))?.toFixed(2),
                    "line": row.line,
                    "totalAmount": parseFloat(totalPayment)?.toFixed(2),

                });
        });

        const todayDate = new Date();
        console.log(todayDate);
        const an8 = getValues().an8;

        const dateArray = {
            day: todayDate.getDate() < 10 ? `0${todayDate.getDate()}` : todayDate.getDate(),
            mounth: todayDate.getMonth() + 1 < 10 ? `0${todayDate.getMonth() + 1}` : todayDate.getMonth() + 1,
            year: todayDate.getFullYear().toString().substr(-2),
            hour: todayDate.getHours() < 10 ? `0${todayDate.getHours()}` : todayDate.getHours(),
            minute: todayDate.getMinutes() < 10 ? `0${todayDate.getMinutes()}` : todayDate.getMinutes(),
            second: todayDate.getSeconds() < 10 ? `0${todayDate.getSeconds()}` : todayDate.getSeconds()
        }

        console.log(dateArray.second);

        const reference = `${paymentArray.length}-${dateArray.day}${dateArray.mounth}${dateArray.year}-${dateArray.hour}${dateArray.minute}${dateArray.second}`.trim();

        setDataStartPayment({
            reference,
            paymentArray
        })

        PaymentService.startPayment(reference, paymentArray, an8)
            .then(() => {

                console.log('ok');
                setIsLoadingStartPayment(false);
                handleOpen(reference);
            })
            .catch((error) => {
                console.log(error);
                setIsLoadingStartPayment(false);

                if (error.response) {

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al almacenar proceso de pago.',
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                        });
                    }
                } else {
                    actionErrorConnection(error, 'Error al almacenar proceso de pago.');
                }
            });
    }

    const savePaymentRequest = (request) => {

        const an8 = getValues().an8;

        const requestToSend = {
            account:request.mp_account,
            product:request.mp_product,
            order:request.mp_order,
            reference:request.mp_reference,
            node:request.mp_node,
            concept:request.mp_concept,
            amount:request.mp_amount,
            signature:request.mp_signature,
            customername:request.mp_customername,
            currency:request.mp_currency,
            urlsuccess:request.mp_urlsuccess,
            urlfailure:request.mp_urlfailure
        }

        PaymentService.savePaymentRequest(requestToSend, an8)
            .then((response) => {
                if(!response.data){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `${response.message}`,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
            .catch((error) => {
                console.log(error);

                if (error.response) {

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al realizar guardado de solicitud.',
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                        });
                    }
                } else {
                    actionErrorConnection(error, 'Error al realizar guardado de solicitud.');
                }
            });
    }

    const cancelPaymentRequest = (dataStart) =>{

        const an8 = getValues().an8;

        const dataPaymentToSend = {
            reference:dataStart.reference,
            bill: dataStart.paymentArray
        };

        PaymentService.cancelPayment(dataPaymentToSend, an8)
            .then((response) => {

                if(!response.data && response.message !== 'Proceso realizado correctamente'){
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `${response.message}`,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar'
                    });
                }
            })
            .catch((error) => {

                if (error.response) {

                    if (sessionDifference > Number(tokenExpired)) {
                        sesionExpired(dispatch, history);
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al terminar proceso de pago.',
                            showConfirmButton: true,
                            confirmButtonText: 'Aceptar'
                        });
                    }
                } else {
                    actionErrorConnection(error, 'Error al terminar proceso de pago.');
                }
            });


    }

    const handleOpen = (reference) => {

        const an8Select = getValues().an8;
        const clientName = customers.data?.find(({ noCustomer }) => noCustomer === an8Select)?.name;

        let dataPaymentContent = {
            mp_account: process.env.REACT_APP_MP_ACCOUNT,
            mp_product: process.env.REACT_APP_MP_PRODUCT,
            mp_order: an8Select,
            mp_reference: reference.trim(),
            mp_node: process.env.REACT_APP_MP_NODE,
            mp_concept: process.env.REACT_APP_MP_CONCEPT,
            mp_amount: amountPayment > 0 ? Number.parseFloat(amountPayment).toFixed(2) : 0,
            mp_signature: sha256.hmac(process.env.REACT_APP_KEY, `${an8Select}${reference}${amountPayment > 0 ? Number.parseFloat(amountPayment).toFixed(2) : 0}`.trim()),
            mp_customername: clientName.trim(),
            mp_currency: process.env.REACT_APP_MP_CURRENCY,
            mp_urlsuccess: baseUrl + process.env.REACT_APP_MP_URLSUCCESS,
            mp_urlfailure: baseUrl + process.env.REACT_APP_MP_URLFAILURE
        };

        savePaymentRequest(dataPaymentContent);

        setDataPayment(dataPaymentContent);

        setOpen(true);

    };

    const handleClose = () => {
        cancelPaymentRequest(dataStartPayment);
        setOpen(false);
    };

      /**
   * Prepara la descarga del archivo
   * @author alSanchez - ETE
   * @version 1.1.0 - Abril 2024
   */
  const downloadFile = () =>{

    setIsDownloadFile(true);

     getDownload(detailPayment);
    }

      /**
   * Prepara la descarga del archivo con las facturas a pagar
   * @author alSanchez - ETE
   * @version 1.0.0 - Abril 2024
   */
  const downloadFileByPayment = (paymentDetail) =>{
    console.log(paymentDetail)

    setIsDownloadFile(true);
    let newPaymentDetail = [];

    paymentDetail?.paymentArray.forEach(({billNumber})=>{
        const paymentFind = detailPayment.find(({number})=> number === billNumber);
        if(paymentFind) newPaymentDetail.push(paymentFind);

    })

     getDownload(newPaymentDetail);
    }

    /**
   * Genera la descarga del archivo
   * @param {Object} detail - detalle de las facturas a recuperar
   * @author alSanchez - ETE
   * @version 1.0.0 - Abril 2024
   */

    const getDownload = (detail) =>{
        const params = getValues();
        const dataFileName = {
            an8: params.an8,
            startDate: selectStartDate ? selectStartDate : dateMax,
            endDate: selectEndDate ? selectEndDate : dateMax
        }
        
      const fileName = `detalle_facturas_${params.an8}_${dataFileName.startDate?.toLocaleDateString()}-${dataFileName.endDate?.toLocaleDateString()}`;

        PaymentService.downloaddataPaymentsDetailXlsx(detail, dataFileName.an8).then(
            (response)=>{
              console.log('ok descarga');

              const byteString = window.atob(response.split(',')[1]); // leer dato serial en base64
              const mimeString = response.split(',')[0].split(':')[1].split(';')[0]; //Formate string

              const ab = new ArrayBuffer(byteString.length); //crear un buffer de adtos binarios con longitud igual a los datos contenidos en el archivo
              const ia = new Uint8Array(ab); //Se crea un array Undefinedint8 para poder manipular el contenedor de ab
              for (let i = 0; i < byteString.length; i++) {
                ia[i] = byteString.charCodeAt(i)    //a cada posicion de ia se le asigna el valor del caracter codificado en la posicion de byteString
              }

              const dataBlob = new Blob([ab], { type: mimeString }); // Se indica que es un tipo de dato Blob, para manejar datos binarios grandes

              if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(dataBlob, `${fileName}.xls`);
                setIsDownloadFile(false);
                return
              }  // Crear el nombre del archivo

              const url = window.URL.createObjectURL(dataBlob);
              const link = document.createElement('a');
              link.href = url
              link.setAttribute('download', `${fileName}.xls`);
              document.body.appendChild(link);
              link.click();
              link.remove();  // Se descarga automaticamente y posteriormente se elimina el link que genera dicha descarga
 
              setIsDownloadFile(false);
            },
            (error)=>{
              setIsDownloadFile(false);
              actionErrorConnection(error, 'Error al descargar archivo xls.');
            });
          console.log('descargar archivo xls');
    }



    return (
        <>
            <div className="container-fluid p-0 m-0">
                <div className="row flex-nowrap p-0 m-0">
                    <div className="col-auto col-md-3 col-xl-2 p-0 d-none d-sm-block">
                        <SidebarMenu />
                    </div>
                    <div className="col p-0 ms-1 me-1">
                        <NavTopMenu />
                        <div className="container ps-3 pe-3 container-size">
                            <div className="row base-container ">
                                <div className="col-12 border-title text-title pt-2 pb-2 ps-4 h4">
                                    <span>Pago de facturas</span>
                                </div>
                                <div className="col-12 pt-3 pb-3 ps-4 pe-4">
                                    <div className="row ">
                                        <div className="col-12 ">
                                            <div className=" d-flex justify-content-end">
                                                {(customers.isLoading) &&
                                                    <Tooltip title="Cargando filtro..." placement="top-start" arrow>
                                                        <div className="custom-icon-loading me-1">
                                                            <i className="fas fa-spinner fa-spin"></i>
                                                        </div>
                                                    </Tooltip>
                                                }
                                                {
                                                    isDownloadFile ?
                                                    <Tooltip title="Descargargando..." placement="top-start" arrow>
                                                    <div className="custom-icon-loading me-1">
                                                        <i className="fas fa-spinner fa-spin"></i>
                                                    </div>
                                                    </Tooltip>
                                                    :
                                                    <Tooltip title="Descargar resultados" placement="top-start" arrow>
                                                    <div>
                                                        <button
                                                        className="btn custom-btn-icons"
                                                        onClick={()=>downloadFile()}
                                                        type="button"
                                                        disabled={isLoadingData || isErrorResponse || detailPayment.length < 1}
                                                        >
                                                        <i className="fas fa-download"></i>
                                                        </button>
                                                    </div>
                                                    </Tooltip>
                                                }
                                                <Tooltip title="Filtrar" placement="top-start" arrow>
                                                    <button
                                                        className="btn custom-btn-icons"
                                                        type="button"
                                                        data-bs-toggle="collapse"
                                                        data-bs-target="#collapseExample"
                                                        aria-expanded="false"
                                                        aria-controls="collapseExample"
                                                    >
                                                        <i className="fas fa-filter"></i>
                                                    </button>
                                                </Tooltip>
                                            </div>
                                            <div className="collapse show" id="collapseExample">
                                                <div className="filter-continer">
                                                    <div className="container mt-3">
                                                        <form className="row">
                                                            <div className="col-12 mb-3">
                                                                <FormControl component="fieldset" className=" w-100 ">
                                                                    <FormLabel className="filterName" component="legend">Estado de facturas</FormLabel>
                                                                    <RadioGroup className="ms-md-12 ps-md-12 w-100" aria-label="invoice" name="invoice" row value={selectedStatusValue} onChange={handleChangeStatus}>
                                                                        <FormControlLabel value='true' control={<CustomRadio />} label="Facturas pagadas" />
                                                                        <FormControlLabel value='false' control={<CustomRadio />} label="Facturas pendientes" />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                            </div>
                                                            <div className="col-md-12 col-lg-12 mb-3">
                                                                <span className="filterName">Seleccionar Filtros</span>
                                                            </div>
                                                            <div className="col-md-5 col-lg-4 mb-3">
                                                                <TextField
                                                                    select
                                                                    id="an8"
                                                                    name="an8"
                                                                    label="Num. cliente*"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    disabled={customers.isDisabled || customers.isLoading}
                                                                    fullWidth
                                                                    defaultValue={''}
                                                                    {...register('an8')}
                                                                    onBlur={onCustomerChange}
                                                                >
                                                                    <MenuItem value="">Seleccionar cliente</MenuItem>
                                                                    {customers.data.map(({ noCustomer, name }) => (
                                                                        <MenuItem key={noCustomer} value={noCustomer}>
                                                                            {noCustomer} - {name}
                                                                        </MenuItem>
                                                                    ))}
                                                                </TextField>
                                                            </div>
                                                            <div className="col-md-5 col-lg-4 mb-3">
                                                                <MuiPickersUtilsProvider
                                                                    utils={DateFnsUtils}
                                                                    locale={esLocale}>
                                                                    <DatePicker
                                                                        disableToolbar
                                                                        autoOk
                                                                        fullWidth
                                                                        required
                                                                        control={control}
                                                                        id="startDate"
                                                                        name="startDate"
                                                                        inputVariant="outlined"
                                                                        variant="inline"
                                                                        label="Fecha factura inicio"
                                                                        size="small"
                                                                        format="dd/LLLL/yyyy"
                                                                        value={selectStartDate}
                                                                        onChange={handleStartDateChange}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            </div>
                                                            <div className="col-md-5 col-lg-4 mb-3">
                                                                <MuiPickersUtilsProvider
                                                                    utils={DateFnsUtils}
                                                                    locale={esLocale}>
                                                                    <DatePicker
                                                                        disableToolbar
                                                                        autoOk
                                                                        fullWidth
                                                                        required
                                                                        control={control}
                                                                        id="endDate"
                                                                        name="endDate"
                                                                        inputVariant="outlined"
                                                                        variant="inline"
                                                                        label="Fecha factura Fin"
                                                                        size="small"
                                                                        format="dd/LLLL/yyyy"
                                                                        minDate={selectStartDate}
                                                                        minDateMessage="La fecha debe ser mayor a la de inicio"
                                                                        value={selectEndDate}
                                                                        onChange={handleEndDateChange}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            </div>
                                                            <div className="col-md-5 col-lg-4 mb-3">
                                                                <TextField
                                                                    select
                                                                    id="typeInvoice"
                                                                    name="typeInvoice"
                                                                    label="Tipo de factura"
                                                                    variant="outlined"
                                                                    size="small"
                                                                    fullWidth
                                                                    defaultValue={''}
                                                                    disabled={invoiceType.isDisabled || invoiceType.isLoading}
                                                                    {...register('typeInvoice')}
                                                                >
                                                                    <MenuItem value="">Seleccionar tipo factura</MenuItem>
                                                                    {invoiceType.data?.map((option) => (
                                                                    <MenuItem key={option} value={option}>
                                                                        {option}
                                                                    </MenuItem>
                                                                    ))}
                                                                </TextField>
                                                            </div>
                                                            <div className="col-md-5 col-lg-4 mb-3">
                                                                <MuiPickersUtilsProvider
                                                                    utils={DateFnsUtils}
                                                                    locale={esLocale}>
                                                                    <DatePicker
                                                                        disableToolbar
                                                                        autoOk
                                                                        fullWidth
                                                                        control={control}
                                                                        id="startExpirationDate"
                                                                        name="startExpirationDate"
                                                                        inputVariant="outlined"
                                                                        variant="inline"
                                                                        label="Fecha vencimiento inicio"
                                                                        size="small"
                                                                        format="dd/LLLL/yyyy"
                                                                        minDateMessage="La fecha debe ser mayor a la de inicio"
                                                                        value={selectStartExpitationDate}
                                                                        onChange={handleStartExpirationDateChange}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            </div>
                                                            <div className="col-md-5 col-lg-4 mb-3">
                                                                <MuiPickersUtilsProvider
                                                                    utils={DateFnsUtils}
                                                                    locale={esLocale}>
                                                                    <DatePicker
                                                                        disableToolbar
                                                                        autoOk
                                                                        fullWidth
                                                                        control={control}
                                                                        id="endExpirationDate"
                                                                        name="endExpirationDate"
                                                                        inputVariant="outlined"
                                                                        variant="inline"
                                                                        label="Fecha vencimiento fin"
                                                                        size="small"
                                                                        format="dd/LLLL/yyyy"
                                                                        minDate={selectStartExpitationDate}
                                                                        minDateMessage="La fecha debe ser mayor a la de inicio"
                                                                        value={selectEndExpitationDate}
                                                                        onChange={handleEndExpirationDateChange}
                                                                    />
                                                                </MuiPickersUtilsProvider>
                                                            </div>
                                                            <div className="col-12 w-100 d-flex justify-content-end">
                                                                <Tooltip title={(selectStartDate ? (!selectStartDate || !selectEndDate) : (!selectStartExpitationDate || !selectEndExpitationDate)) ? "Completar filtros obligatorios" : "Buscar"} placement="top-start" arrow>
                                                                    <div>
                                                                        <button
                                                                            className="ms-2 mb-3 btn custom-btn"
                                                                            disabled={isLoadingData || (selectStartDate ? (!selectStartDate || !selectEndDate) : (!selectStartExpitationDate || !selectEndExpitationDate))}
                                                                            onClick={handleSubmit(onSubmit)}
                                                                            type='submit'
                                                                            data-bs-toggle="collapse"
                                                                            data-bs-target="#collapseExample"
                                                                            aria-expanded="false"
                                                                            aria-controls="collapseExample"
                                                                        >
                                                                            <i className="fas fa-search"></i>
                                                                        </button>
                                                                    </div>
                                                                </Tooltip>
                                                            </div>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12">
                                            <Table
                                                selectedStatus={selectedStatusValue}
                                                onAmountChange={amount => setAmountPayment(amount)}
                                                totalColumns={columns}
                                                data={detailPayment}
                                                an8={getValues().an8}
                                            />
                                            {(isErrorResponse) &&
                                                <div className="error-message border-content pt-4 pb-4">
                                                    <span className="">{errorResponse && errorResponse.toString()}</span>
                                                </div>}
                                            {(isLoadingData) &&
                                                <div className=" border-content pt-4 pb-4 custom-icon-loading">
                                                    <i className="fas fa-spinner fa-spin"></i>
                                                </div>}
                                            {(detailPayment.length === 0 && !isLoadingData && !isErrorResponse) &&
                                                <div className="element-row-message border-content pt-4 pb-4 ">
                                                    <span>Los filtros seleccionanos no devolvieron coincidencias.</span>
                                                </div>}
                                        </div>

                                        <div className="col-12">
                                            <div className="row">
                                                {detailPayment.filter(({ isChecked }) => isChecked === true)?.length > 0 &&
                                                    <div className="col-12">
                                                        <div className="row d-flex justify-content-end">
                                                            <div className=" col-6 border-selected-payment">
                                                                <span className="d-block mb-3">Facturas seleccionadas: {detailPayment.filter(({ isChecked }) => isChecked === true)?.length}</span>
                                                                <span className="d-block">Importe: $ {parseFloat(amountPayment)?.toLocaleString('es-Mx')}</span>
                                                            </div>
                                                            <div className=" col-12 d-flex justify-content-end">
                                                                <Tooltip title={detailPayment.filter(({ amountPayableError }) => amountPayableError === true)?.length > 0 ? 'importes no validos' : (isBlocked ? 'El cliente seleccionado no puede generar pagos' : '')} placement="top-start" arrow>
                                                                    <div className="">
                                                                        <button className="btn custom-btn pt-1 pb-2 ps-3 pe-3"
                                                                            type="button"
                                                                            disabled={detailPayment.filter(({ amountPayableError }) => amountPayableError === true)?.length > 0 || isLoadingStartPayment || isBlocked}
                                                                            onClick={startServicePaiment}
                                                                        >
                                                                            <div className="d-flex align-items-center">
                                                                                <span>Procesar pago</span>
                                                                                <span className="pt-1 ps-2">
                                                                                    {
                                                                                        isLoadingStartPayment
                                                                                            ? <i className="fas fa-spinner fa-spin"></i>
                                                                                            : <i className="fas fa-angle-right"></i>
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        </button>
                                                                    </div>
                                                                </Tooltip>
                                                                <Modal
                                                                    open={open}
                                                                    onClose={handleClose}
                                                                >
                                                                    <div className="custom-modal-position p-4">
                                                                        <div className="container">
                                                                            <div className="row">
                                                                                <div className="col-12 d-flex justify-content-center mb-4">
                                                                                    <span className="icon-container d-flex align-items-center justify-content-center">
                                                                                        <i className="fas fa-exclamation custom-icon-alert"></i>
                                                                                    </span>
                                                                                </div>
                                                                                <div className="col-12 d-flex justify-content-center mb-4">
                                                                                    <span className="text-modal-title">Iniciando proceso de pago...</span>
                                                                                </div>
                                                                                <div className="col-12 d-flex justify-content-center mb-4">
                                                                                    <span className="d-block text-modal">Será redireccionado al portal de pagos.</span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="row ">
                                                                                <div className="col-12 mt-2 pt-2 d-flex justify-content-center">
                                                                                    <button
                                                                                        className="btn custom-btn-icon-action pt-1 pb-1 ps-2 pe-2 me-3"
                                                                                        type="button"
                                                                                        onClick={()=>downloadFileByPayment(dataStartPayment)}>
                                                                                        Descargar detalle {isDownloadFile ? <i className="fas fa-spinner fa-spin"></i> : <i className="fas fa-download"></i>}
                                                                                    </button>
                                                                                    <button
                                                                                        className="btn custom-cancel-btn pt-1 pb-1 ps-2 pe-2 me-3"
                                                                                        type="button"
                                                                                        onClick={handleClose}>
                                                                                        Cancelar
                                                                                    </button>
                                                                                    <form method="post" action={process.env.REACT_APP_MP_URL}>
                                                                                        <input type="hidden" name="mp_account" value={dataPayment.mp_account} />
                                                                                        <input type="hidden" name="mp_order" value={dataPayment.mp_order} />
                                                                                        <input type="hidden" name="mp_reference" value={dataPayment.mp_reference} />
                                                                                        <input type="hidden" name="mp_customername" value={dataPayment.mp_customername} />
                                                                                        <input type="hidden" name="mp_product" value={dataPayment.mp_product} />
                                                                                        <input type="hidden" name="mp_node" value={dataPayment.mp_node} />
                                                                                        <input type="hidden" name="mp_concept" value={dataPayment.mp_concept} />
                                                                                        <input type="hidden" name="mp_amount" value={dataPayment.mp_amount} />
                                                                                        <input type="hidden" name="mp_currency" value={dataPayment.mp_currency} />
                                                                                        <input type="hidden" name="mp_signature" value={dataPayment.mp_signature} />
                                                                                        <input type="hidden" name="mp_urlsuccess" value={dataPayment.mp_urlsuccess} />
                                                                                        <input type="hidden" name="mp_urlfailure" value={dataPayment.mp_urlfailure} />
                                                                                        <button
                                                                                            className="btn custom-btn pt-1 pb-2 ps-3 pe-3"
                                                                                            type="submit">
                                                                                            <div className="btn custom-btn pt-1 pb-1 ps-2 pe-2">
                                                                                                <span>Aceptar</span>
                                                                                            </div>
                                                                                        </button>
                                                                                    </form>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </Modal>
                                                            </div>

                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

PaymentScreen.propTypes = {
    row: PropTypes.any,
    getToggleAllRowsSelectedProps: PropTypes.any
};

const Table = ({ totalColumns, data, onAmountChange, selectedStatus, an8 }) => {

    const currencySelected = 'es-Mx'

    const [columnsDetected, setColumnsDetected] = useState([]);

    useEffect(() => {

        totalColumns[0].isVisible = selectedStatus === 'false' && totalColumns[0].isVisible ? true : false; // se agregara la condicional para el rol cuando se tenga
        setColumnsDetected(totalColumns.filter(column => column.isVisible))

    }, [totalColumns, setColumnsDetected, selectedStatus]);

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        prepareRow,
    } = useTable({
        columns: columnsDetected,
        data,
    },
        useRowSelect,
    );

    useEffect(() => {
        if (selectedStatus === 'false') {


            let selectedRows = data.filter(({ isChecked }) => isChecked === true);

            let sumAmount = 0;

            selectedRows.forEach(row => sumAmount += parseFloat(row?.amountPayable?.replace(/,/g,'')));
            onAmountChange(parseFloat(sumAmount).toFixed(2));
        }

    }, // eslint-disable-next-line react-hooks/exhaustive-deps
        [onAmountChange, selectedStatus]);

    return (
        <>

            <table
                className=""
                {...getTableProps()}
            >
                <thead>
                    {headerGroups.map((headerGroup, i) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="element-header-content border-content " key={i}>
                            {headerGroup.headers.map((column, j) => (
                                <th {...column.getHeaderProps()}
                                    className="border-element header-element header-text pt-3 pb-3" key={j}>
                                    {column.render("Header")}
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {rows.map((row) => {
                        prepareRow(row);
                        return (
                            <React.Fragment key={row.getRowProps().key}>
                                <tr className="element-row border-content">
                                    {row.cells.map((cell, i) => {
                                        return (
                                            <td className="border-element content-text padding-row-actions"
                                                key={i}
                                                {...cell.getCellProps()}>
                                                {
                                                    cell.column.id === 'an8' ?
                                                        an8
                                                        : ((cell.column.Header === 'Importe factura' || cell.column.Header === 'Importe pendiente') ?
                                                            `$ ${parseFloat(cell.value).toLocaleString(currencySelected)}` : cell.render("Cell"))
                                                }
                                            </td>
                                        );
                                    })}
                                </tr>
                            </React.Fragment>
                        );
                    })}
                </tbody>
            </table>

        </>)
}

Table.propTypes = {
    totalColumns: PropTypes.any,
    data: PropTypes.any,
    onAmountChange: PropTypes.any,
    selectedStatus: PropTypes.any,
    an8: PropTypes.any
};